import styled, { css } from 'styled-components';
import { ColorAddiFontError } from '@addi/foundation/dist/web/colors';
import { TextArea, InputLabel } from './TextInput.styled';
export const InputContainer = styled.div `
    width: 100%;
    height: auto;
    position: relative;

    ${props => props.error && css `
        ${InputLabel} > span {
            color: ${ColorAddiFontError};
        }
        ${TextArea} {
            border-color: ${ColorAddiFontError};
        }

    `}
`;
//# sourceMappingURL=TextAreaInput.Styled.js.map